import React from "react";

import {
  Box,
  BoxProps,
  Link,
  List,
  ListItem,
  ListProps,
} from "@catchoftheday/cg-components";

import { NavigationLinkColumns, NavLink } from "../../types";
import { Body,Title } from "../primitives";

type ColumnNavigationProps = {
  navigationLinkColumns: NavigationLinkColumns[];
} & BoxProps;

export function ColumnNavigation({
  navigationLinkColumns,
  ...boxProps
}: ColumnNavigationProps) {
  return (
    <Box
      as="nav"
      display="flex"
      justifyContent="space-between"
      width="100%"
      {...boxProps}
    >
      {navigationLinkColumns.map(({ columnTitle, links }) => (
        <Links
          key={columnTitle}
          title={columnTitle}
          links={links}
          width={`${100 / navigationLinkColumns.length}%`}
          paddingRight="40px"
        />
      ))}
    </Box>
  );
}

type LinksProps = {
  title: string;
  links: NavLink[];
} & ListProps;

const Links = ({ title, links, ...listProps }: LinksProps) => {
  return (
    <List {...listProps}>
      <ListItem>
        <Title>{title}</Title>
      </ListItem>
      {links.map(
        ({ text, url, openInNewWindow, isBrightEdgeAutoPilotEnabled }) => {
          if (isBrightEdgeAutoPilotEnabled) {
            return <div key={text} className="be-ix-link-block"></div>;
          }

          return (
            <ListItem key={text} marginBottom={"5px"}>
              <Link
                href={decodeURIComponent(url)}
                target={openInNewWindow ? "_blank" : undefined}
                rel={openInNewWindow ? "noopener noreferrer" : undefined}
              >
                <Body margin={0}>{text}</Body>
              </Link>
            </ListItem>
          );
        }
      )}
    </List>
  );
};
